import { css, Theme } from '@emotion/react'
import { chipClasses } from '@mui/material'
import { COURSE_COLORS } from 'theme/utils'
import { ALL_SUBJECT_ID } from './useTaskFilters'

export const headerWrapper = css`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  span {
    font-weight: 700;
  }
`

export const headerButtonsWrapper = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 12px;

  margin-top: -41px;
  margin-left: auto;
  margin-bottom: ${theme.spacing(2)};

  ${theme.breakpoints.down(620)} {
    margin-top: ${theme.spacing(2)};
    justify-content: left;
    width: 100%;
  }
`

export const newTaskButton = css`
  padding: 10px 20px;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const chipWrapper = (subject: string) => css`
  width: fit-content;

  ${subject === ALL_SUBJECT_ID &&
  css`
    border-radius: 6px;

    background: linear-gradient(270deg, #fff0d4 0%, #eddafe 100%);
    padding: 1px;
  `}
`

const getChipStyles = (subject: string) => {
  if (subject === ALL_SUBJECT_ID) {
    return css`
      position: relative;
      background-color: white;

      border-radius: 5px;

      ::after {
        content: '';
        position: absolute;
        top: -1px;
        bottom: -1px;
        left: -1px;
        right: -1px;

        border: 1px solid transparent;
        border-radius: 5px;

        background: linear-gradient(
          270deg,
          rgba(255, 193, 73, 0.1) 0%,
          rgba(255, 85, 95, 0.1) 48.85%,
          rgba(178, 100, 255, 0.1) 100%
        );
      }

      .${chipClasses.label} {
        background: linear-gradient(270deg, #ffc149 0%, #ff555f 48.85%, #b264ff 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    `
  }

  return css`
    border: 1px solid ${COURSE_COLORS[subject as keyof typeof COURSE_COLORS]?.secondary};
    border-radius: 6px;

    background-color: ${COURSE_COLORS[subject as keyof typeof COURSE_COLORS]?.soft};
    color: ${COURSE_COLORS[subject as keyof typeof COURSE_COLORS]?.main};
  `
}

export const subjectChip = (subject: string) =>
  css`
    ${getChipStyles(subject)};

    padding: 5px 9px;

    .${chipClasses.label} {
      padding: 0;

      font-size: 14px;
      font-weight: 500;
      line-height: normal;
    }
  `
